/**
 * mwApp.acls module <br>
 * Work with acls
 *
 * @namespace mwApp/acls
 */

import aclsConfig from './acls.config'
import AddAclCtrl from './addAcl.controller'
import AclListCtrl from './aclList.controller'
import AclsIntersections from './aclsIntersections.controller'

export default
angular.module('mwApp.acls', [])
  .config(aclsConfig)
  .controller('AclListCtrl', AclListCtrl)
  .controller('AclsIntersections', AclsIntersections)
  .controller('AddAclCtrl', AddAclCtrl)
